import { render, staticRenderFns } from "./CharactersLeftCopySection.vue?vue&type=template&id=0cc63bcd"
import script from "./CharactersLeftCopySection.vue?vue&type=script&lang=js"
export * from "./CharactersLeftCopySection.vue?vue&type=script&lang=js"
import style0 from "./CharactersLeftCopySection.vue?vue&type=style&index=0&id=0cc63bcd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports